<template>
  <FormInput v-model="modelValue" type="number" :name  :placeholder="$t('LoginOrReg.PhoneCodeTips')" autocomplete="off" maxlength="4" autocapitalize="off"
    :rules="[
      {
        validator: (value: string) => value.length === 4,
        message: $t('LoginOrReg.PhoneCodeErrorTips'),
        trigger: 'onChange',
      },
    ]" :left-icon="codeIcon">
    <template #right-icon>
      <van-button size="small" :loading="loading" @click="handleSendCode" class="primaryBtn-thin !h-[26px] px-[12px] !w-[76px]"
        :disabled="!canSend">
        {{ countdown ? `${countdown}s` : $t('LoginOrReg.PhoneCodeErrorTips') }}
      </van-button>
    </template>
  </FormInput>
</template>

<script setup lang="ts">
  import FormInput from '@a/components/FormInput';
  import codeIcon from '@a/assets/images/i_code.png'
  import debounce from 'lodash-es/debounce'
  import { getLimitedSms } from '@/api/phoneSms'
  import { validatePhoneNumber } from '@/utils/validate'
  const props = withDefaults(
    defineProps<{
      phone: string
      // placeholder?: string
      // errorMsg?: string
      onCaptchaIdChange?: (newCaptchaId: string) => void;
      name?: string
    }>(),
    {
      // placeholder: 'Insira o código',
      // errorMsg: 'Insira o código de verificação de 4 dígitos.',
      name: 'phoneCode',
    },
  )

  const modelValue = defineModel<string>()

  const countdown = ref(0);
  const loading = ref(false);

  // 发送验证码
  const onSend = debounce(async () => {
    loading.value = true;
    try {
      const { code, data } = await getLimitedSms({
        captchaType: 'Register',
        phoneNumber: props.phone
      });
      if (code === 200) {
        countdown.value = 60;
        props.onCaptchaIdChange?.(data.captchaId);
      }
    } finally {
      loading.value = false;
    }
  }, 500);
  
  const canSend = computed(() => {
    return !countdown.value && !loading.value && validatePhoneNumber(props.phone);
  });
  
  // 处理发送验证码
  const handleSendCode = () => {
    if (canSend.value) onSend();
  };

  // 倒计时
  watch(countdown, (newVal) => {
    if (newVal > 0) {
       setTimeout(() => {
        countdown.value--;
      }, 1000);
    }
  });
</script>
